import PopupStructure from "./PopupStructure";
export default PopupStructure;